import React, { useState, useEffect } from "react";
import "../App.css";
import Course from "../components/Course";
import { Helmet } from "react-helmet";

export default function Home(props) {
  return (
    <>
      <Helmet>
        <title>Fiddle School</title>
        <meta name="description" content="Learn to play the fiddle with step-by-step video lessons, expert guidance from Katie Glassman, and a supportive online community." />

        {/* Open Graph */}
        <meta property="og:title" content="Fiddle School" />
        <meta
          property="og:site_name"
          content="Katie Glassman's Fiddle School"
        />
        <meta property="og:description" content="Learn to play the fiddle with step-by-step video lessons, expert guidance from Katie Glassman, and a supportive online community." />
        <meta property="og:type" content="article" />
        <meta
          property="og:image"
          content="https://fiddleschool.com/logo192.png"
        />
        <meta property="og:url" content={window.location.href} />

        {/* Twitter */}
        <meta name="twitter:card" content="https://fiddleschool.com/logo192.png"/>
        <meta name="twitter:title" content="Fiddle School" />
        <meta name="twitter:description" content="Learn to play the fiddle with step-by-step video lessons, expert guidance from Katie Glassman, and a supportive online community." />
        <meta
          name="twitter:image"
          content="https://fiddleschool.com/logo192.png"
        />
      </Helmet>
      <div
        style={{
          width: "100%",
          height: "100%",
          backgroundColor: "#f8f6f1",
          justifyContent: "center",
          alignItems: "center",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Course />
      </div>
    </>
  );
}
